import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMyAssignments } from "../api/services";

function MyAssignments() {
  const [assignments, setAssignments] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAssignments();
  }, []);

  const fetchAssignments = async () => {
    try {
      const res = await getMyAssignments();
      setAssignments(res.data);
    } catch (err) {
      console.error("Failed to load assignments", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>{t("myAssignments")}</h2>

      {loading && <p>Loading assignments...</p>}

      {!loading && assignments.length === 0 && (
        <p>No assignments found.</p>
      )}

      <div style={styles.grid}>
        {assignments.map((item) => (
          <div key={item.id} style={styles.card}>
            <h3>{item.subject_name}</h3>
            <p style={styles.className}>
  {item.department_name
    ? `${item.class_name} (${item.department_name})`
    : item.class_name}
</p>

            <div style={styles.buttonRow}>

              <button
                style={styles.button}
                onClick={() =>
                  (
                    window.location.href =
                    `/teacher/enter-marks/${item.id}`
                  )
                }
              >
                {t("enterMarks")}
              </button>

              <button
                style={styles.attendanceBtn}
                onClick={() =>
                  (
                    window.location.href =
                    `/teacher/attendance/${item.id}`
                  )
                }
              >
                {t("attendance")}
              </button>

            </div>
          </div>
        ))}
      </div>

      <button
        style={styles.back}
        onClick={() => (window.location.href = "/teacher-dashboard")}
      >
        ← {t("backToDashboard")}
      </button>
    </div>
  );
}

const styles = {
  page: {
    padding: "7px",
    fontFamily: "Segoe UI, sans-serif",
  },

  title: {
    marginBottom: "20px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "20px",
  },

  card: {
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    textAlign: "center",
  },

  className: {
    color: "#64748b",
    marginBottom: "12px",
  },

  button: {
    padding: "10px 14px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  buttonRow:{
  display:"flex",
  gap:"10px",
  justifyContent:"center",
  flexWrap:"wrap",
},

attendanceBtn:{
  padding:"10px 14px",
  background:"#16a34a",
  color:"white",
  border:"none",
  borderRadius:"8px",
  cursor:"pointer",
  fontWeight:"600",
},

  back: {
    marginTop: "30px",
    padding: "8px 14px",
    background: "#64748b",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default MyAssignments;